import {
  FORM_DATA_INIT,
  FORM_UPDATE_DATA,
  SITE_ACTIVE_INDEX,
  SECTION_ACTIVE_INDEX,
  SUBSECTION_ACTIVE_INDEX,
  RESET_ACTIVE_INDEX,
  FORM_SAVE_START,
  FORM_SAVE_ERROR,
  FORM_SAVE_END,
  FORM_SUBMIT_START,
  FORM_SUBMIT_ERROR,
  FORM_SUBMIT_END,
} from '../actions/annualRenewals';

const initialState = {
  sites: null,
  id: null,
  submitted: false,
  submitUrl: null,
  saveUrl: null,
  submitErrorMessage: null,
  active: {
    site: 0,
    section: 0,
    subsection: 0,
  },
  last: {
    site: 0,
    section: 0,
  },
  loading: {
    submit: false,
    save: false,
  },
  error: {
    submit: false,
    save: false,
  },
};

export const annualRenewalsReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    // form
    case FORM_DATA_INIT:
      return {
        ...state,
        ...action.payload,
      };
    case FORM_UPDATE_DATA:
      return {
        ...state,
        sites: action.payload,
      };
    // site
    case SITE_ACTIVE_INDEX:
      return {
        ...state,
        active: { ...state.active, site: action.payload },
      };
    // section
    case SECTION_ACTIVE_INDEX:
      return {
        ...state,
        active: { ...state.active, section: action.payload },
      };
    // subsection
    case SUBSECTION_ACTIVE_INDEX:
      return {
        ...state,
        active: { ...state.active, subsection: action.payload },
      };
    case RESET_ACTIVE_INDEX:
      return {
        ...state,
        active: { ...state.active, ...action.payload },
      };
    // form save
    case FORM_SAVE_START:
      return {
        ...state,
        loading: { ...state.loading, save: true },
        error: { ...state.error, save: false },
      };
    case FORM_SAVE_ERROR:
      return {
        ...state,
        loading: { ...state.loading, save: false },
        error: { ...state.error, save: true },
      };
    case FORM_SAVE_END:
      return {
        ...state,
        loading: { ...state.loading, save: false },
      };
    // form submit
    case FORM_SUBMIT_START:
      return {
        ...state,
        loading: { ...state.loading, submit: true },
        error: { ...state.error, submit: false },
      };
    case FORM_SUBMIT_ERROR:
      return {
        ...state,
        loading: { ...state.loading, submit: false },
        error: { ...state.error, submit: true },
      };
    case FORM_SUBMIT_END:
      return {
        ...state,
        submitted: action.payload.submitted,
        loading: { ...state.loading, submit: false },
      };
    default:
      return {
        ...state,
      };
  }
};
